
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","id":"Layer_2","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('style',[_v('.cls-1{fill:#101820}')])]),_c('path',{staticClass:"cls-1",attrs:{"d":"M30 15a1 1 0 01-.58-.19L16 5.23 2.58 14.81a1 1 0 01-1.16-1.62l14-10a1 1 0 011.16 0l14 10A1 1 0 0130 15zM5 9a1 1 0 01-1-1V4a1 1 0 011-1h4a1 1 0 010 2H6v3a1 1 0 01-1 1z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M25 29h-5a1 1 0 01-1-1v-7h-6v7a1 1 0 01-1 1H7a3 3 0 01-3-3V16a1 1 0 012 0v10a1 1 0 001 1h4v-7a1 1 0 011-1h8a1 1 0 011 1v7h4a1 1 0 001-1V16a1 1 0 012 0v10a3 3 0 01-3 3z"}})])
          )
        }
      }
    